<template>
    <div>
        <hts-drawer
            v-model="visible"
            :title="$t('labels.editMarkup')"
            :submit="handleSubmitFormUpdateSettings"
            @close="closeOverSide">
            <hts-form-input
                v-model="globalSettingsInformation.markup"
                :required="true"
                type="number"
                :label="$t('labels.markup')"
                name="markup"
                prop="markup">
                <template #suffix>
                    %
                </template>
            </hts-form-input>
        </hts-drawer>
    </div>
</template>

<script setup lang="ts">
const { $t } = useNuxtApp()

const store = $store()

const visible = ref(false)
const isLoading = ref(false)

const open = (type: { [key: string]: any }) => {
  _initData()
  visible.value = true
}

const globalSettingsInformation = ref({ markup: 0 } as { [key: string]: any })

const _initData = () => {
  isLoading.value = true

  globalSettingsInformation.value = store.globalSettings.getGlobalSettings

  isLoading.value = false
}

const closeOverSide = () => {
  visible.value = false
}

defineExpose({
  open
})

const emits = defineEmits(['close', 'update'])

const handleSubmitFormUpdateSettings = () => {
  const api = $url.settings.updateGlobalSettings
  const dataRequest = { ...globalSettingsInformation.value }
  $api(api, { body: dataRequest })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        emits('update', responseData.data)
        process.client && $toast().success($t('notifications.updateSuccess'))
        closeOverSide()
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
      closeOverSide()
    })
}
</script>
